
import { Card } from 'components/Form/Card';
import Row from 'components/Form/Row';

const BlockListsCard = (props: {data: any, title: string, actionButtons: any,icon:any }): JSX.Element => {
  const blockLists = props.data.blocklists;
  return (
    <Card heading={props.title} actionButtons={props.actionButtons} icon={props.icon}>
      { blockLists.map((blocklist: any) => (
        <Row
          key={blocklist.serverIp || blocklist.server} // Unique key for Row
          title={blocklist.serverIp}
          lbl={blocklist.server}
          val={blocklist.isBlocked ? '❌ Blocked' : '✅ Not Blocked'} />
      ))}
    </Card>
  );
}

export default BlockListsCard;
